import fetch from "@/uilts/request";


export default {
    /**
     * 创建授权书
     */
    async getData(data) {
        return await fetch.post("JiuHua/open", data)
    },

    /**
     * 创建授权书
     */
    async submitOpen(data) {
        return await fetch.post("JiuHua/submitOpen", data)
    },
    /**
     * 创建授权书
     */
    async downloadQr(data) {
        return await fetch.post("JiuHua/downloadQr", data)
    },
    /**
     * 创建授权书
     */
    async getDetail(data) {
        return await fetch.post("JiuHua/getDetail", data)
    },

}
